export const environment = {
  production: false,
  apiBaseUrl: 'https://api.stage.bikaji.distiz.com/api',
  apiversion: 1.0,
  reportApiBaseUrl: 'https://distizreportqa.bikaji.com/api',
  adminApiBaseUrl: 'https://localhost:7140'
};